import React from "react";
import { createComponent } from "@lit/react";
import { BeamCommunityImpact as _BeamCommunityImpact } from "./index";

export const BeamCommunityImpact = createComponent({
  tagName: _BeamCommunityImpact.tagName,
  elementClass: _BeamCommunityImpact,
  react: React,
  events: {},
});

export default BeamCommunityImpact; // default alias for use with async import utils like next/dynamic and react.lazy
